import DocumentTitle from 'components/common/DocumentTitle'
import {createBrowserRouter, Navigate} from 'react-router-dom'
import AppLayout from 'layouts/AppLayout'
import EmailBodyContextProvider from 'context/email-body'
import EmailBody from 'components/pages/EmailInbox/EmailBody'
import AppProvider from 'context/AppProvider'
import GeneralError from 'components/common/GeneralError'
import authenticationRoutes from './AuthenticationRoutes'
import knowledgebaseRoutes from './sub-routes/Knowledgebase/KBRoutes'
import analyticsRoutes from './sub-routes/Analytics/AnalyticsRoutes'
import statusPageRoutes from './sub-routes/StatusPage/StatusPageRoutes'
import assetsRoutes from './sub-routes/Assets/AssetsRoutes'
import customersRoutes from './sub-routes/Customers/CustomersRoutes'
import settingsRoutes from './sub-routes/Settings/SettingsRoutes'
import clientPortalRoutes from './sub-routes/ClientPortal/ClientPortalRoutes'

const routesWithAppLayout = [
  {
    element: <AppLayout />,
    children: [
      {
        path: 'getting-started',
        lazy: () => import('pages/authenticated/GettingStarted'),
        handle: {title: 'Getting Started'},
      },
      {path: 'home', lazy: () => import('pages/authenticated/Home'), handle: {title: 'Home'}},
      {path: 'inbox', lazy: () => import('pages/authenticated/Email'), handle: {title: 'Inbox'}},
      {path: 'inbox/:id', lazy: () => import('pages/authenticated/Email'), handle: {title: 'Inbox'}},

      {path: 'tasks', lazy: () => import('pages/authenticated/Tasks'), handle: {title: 'Tasks'}},
      ...knowledgebaseRoutes,
      ...analyticsRoutes,
      ...statusPageRoutes,
      ...assetsRoutes,
      ...customersRoutes,
      ...settingsRoutes,
    ],
  },
]

const routes = [
  {
    element: <AppProvider />,
    children: [
      {
        lazy: () => import('navigation/ProtectedRoute'),
        children: [
          ...routesWithAppLayout,
          {
            path: '/conversation/:id',
            element: (
              <EmailBodyContextProvider>
                <EmailBody />
              </EmailBodyContextProvider>
            ),
            handle: {
              title: 'Email Body',
            },
          },
          ...clientPortalRoutes,
        ],
      },
    ],
  },
]

const appRoutes = createBrowserRouter(
  [
    {
      element: <DocumentTitle />,
      errorElement: <GeneralError />,
      children: [{index: true, element: <Navigate to="home" />}, ...authenticationRoutes, ...routes],
    },
  ],
  {basename: '/support'}
)

export default appRoutes
